<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<h1>LIST OF PHOTOS</h1>
<p class="tocitem2" style="margin-top:50pt"><a href="#/html/10_chap3#pic1">Photo 1 Three-Finger Front, Top View</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic2">Photo 2 Three-Finger Front, Bottom View</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic3">Photo 3 Three-Finger Front, Side View</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic4">Photo 4 Yuri’s 3-Finger Diagonal Grip, Side View</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic5">Photo 5 2-Finger O-Ring, Top View</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic6">Photo 6 2-Finger O-Ring, Bottom View</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic7">Photo 7 Pincer Grip (Thumb and Middle Finger)</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic8">Photo 8 Pincer Grip Variation (Thumb and Middle Finger)</a></p>
<p class="tocitem2"><a href="#/html/10_chap3#pic9">Photo 9 5-Finger Pincer</a></p>
<p class="tocitem2"><span href="#/html/12_chap5#pic10" title="Link target outside of Sample">Photo 10 Dice Barrel With Level</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_listofphotos.vue?2b0a83ec